import { ALL_GRID_IDS } from "@observe-tech/utils";
import type { GridMap, ScreenLayout } from "@observe-tech/utils";

export const emptyGridMap = <
  Cams extends number[] = number[],
>(): GridMap<Cams> =>
  Object.fromEntries(ALL_GRID_IDS.map((id) => [id, null])) as GridMap<Cams>;

export const defaultScreenLayoutValues: Omit<ScreenLayout, "id"> = {
  isShowing: true,
  screenType: "welcome",
  screenData: {
    fullScreen: null,
    halfScreenLeft: null,
    halfScreenRight: null,
    gridLayout: {
      columns: 2,
      rows: 2,
    },
    nCams: 1,
    videoAspectRatio: 1,
    cameraGrid: emptyGridMap(),
    cageGrid: emptyGridMap(),
  },
  feedScreenData: {
    sites: { siteIds: [] },
    columns: [],
    copilotColumns: [],
    filters: [],
  },
};
